// extracted by mini-css-extract-plugin
export default {"removeAction":"RoomItem_removeAction__fFF9y"};